<template>
  <el-dialog v-dialogDrag :title="MessageDialogTitle" @close='closeDialog' v-if="MessageDialogVisible"
             :visible.sync="MessageDialogVisible" width="70vw" class="dialog-body-fixed">
    <el-container>
      <el-header>
        <el-card :body-style="{ padding: '15px 0 0 0' }">
          <!-- 条件搜索 -->
          <el-form :model="queryParams" label-suffix="：" :inline="true" class="el-form--search-box">
            <el-form-item label="消息标题">
              <el-input v-model="queryParams.messageTitle" clearable/>
            </el-form-item>
            <el-form-item label="消息级别">
              <el-select v-model="queryParams.messageLevel" @clear="clearMessageLevel" clearable placeholder="全部">
                <el-option v-for="item in dataDict" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="queryParams.didRead" clearable placeholder="全部">
                <el-option label="已读" value="1"></el-option>
                <el-option label="未读" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="searchList">查询</el-button>
              <el-button icon="el-icon-refresh-right" @click="resetList">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-header>

      <!-- 批量操作 -->
      <el-header v-if="systemMessageList.length > 0">
        <el-button type="success" @click.native="batchRevoke">标为已读</el-button>
        <el-button type="warning" @click.native="batchDelete">批量删除</el-button>
      </el-header>


      <!-- 表格数据 -->
      <el-main>
        <el-card v-if="systemMessageList.length <= 0" class="el-card--nodata">
          <div>
            <div></div>
            <span>无系统消息</span>
          </div>
        </el-card>
        <el-table stripe height="100%" v-else class="el-table--standard" @selection-change="handleSelectionChange"
                  :data="systemMessageList" border @sort-change="sortChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="序号" fixed type="index" width="52" align="center" :index="indexMethod">
          </el-table-column>
          <el-table-column prop="messageTitle" label="消息标题" align="center" width="290" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="messageLevel" label="消息级别" align="center" width="90">
            <template slot-scope="{row}">
              {{ row.messageLevelName }}
            </template>
          </el-table-column>
          <el-table-column prop="messageDescription" width="504" label="消息描述" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="didRead" label="状态" align="center" width="92">
            <template slot-scope="{row}">
              {{ row.didReadName }}
            </template>
          </el-table-column>
          <el-table-column prop="creationTime" label="创建时间" align="center" width="180">
          </el-table-column>
        </el-table>
      </el-main>

      <!-- 分页信息 -->
<!--      <el-footer style="margin-bottom:1.5vh">-->
<!--        <pagination :queryParams="queryParams" @pagination="paginationChange"/>-->
<!--      </el-footer>-->
    </el-container>
  </el-dialog>
</template>

<script>
  import Pagination from '@/components/Pagination'

  export default {
    name: 'messageList',
    components: {Pagination},
    data() {
      return {
        MessageDialogTitle: '系统消息',
        MessageDialogVisible: false,
        dataDict: [],
        queryParams: {
          //查询条件参数集合
          page: this.common.page, //当前页
          limit: 10, //每页数据条数
          total: undefined, //列表数据总条数
          sortord: '', //排序
          messageTitle: undefined,
          messageLevel: undefined,
          didRead: undefined
        },
        systemMessageList: [], //列表数据
        systemMessageList2: [],
        selectionMessageList: []//对选选中的数据
      }
    },
    methods: {
      //批量删除
      batchDelete() {
        if (this.selectionMessageList.length <= 0) {
          this.$message({
            message: '请先选中数据',
            type: 'warning'
          });
          return;
        }
        this.$confirm('您确定要删除选中的消息吗？', '信息确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.common
            .httpPost(
              '批量删除',
              '/admin/system/systemMessages/batchDelete',
              this.selectionMessageList
            )
            .then((res) => {
              if (res != undefined) {
                //页面内的多选集合情况
                this.selectionMessageList = [];
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                //删除成功，通知首页的组件刷新数据
                this.$store.dispatch("initUpdateMessageStatus", !this.$store.getters.updateMessageStatus)
              }
            })
        })
          .catch(() => {
          })
      },
      //标为已读
      batchRevoke() {
        if (this.selectionMessageList.length <= 0) {
          this.$message({
            message: '请先选中数据',
            type: 'warning'
          });
          return;
        }
        this.$confirm('您确定要修改选中的数据状态为已读吗？', '信息确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.common
            .httpPost(
              '标为已读',
              '/admin/system/systemMessages/batchRevoke',
              this.selectionMessageList
            )
            .then((res) => {
              if (res != undefined) {
                //页面内的多选集合情况
                this.selectionMessageList = [];
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                //已读成功，通知首页的组件刷新数据
                this.$store.dispatch("initUpdateMessageStatus", !this.$store.getters.updateMessageStatus)
              }
            })
        })
          .catch(() => {
          })
      },
      //接收多选选中的数据
      handleSelectionChange(val) {
        this.selectionMessageList = val;
      },
      sortChange(column) {
        this.queryParams.sortord = column.order
          ? column.prop + ' ' + column.order.replace('ending', '')
          : (this.queryParams.sortord = '')
        this.getList(this.queryParams)
      },
      closeDialog() {
        this.queryParams = {
          //查询条件参数集合
          page: this.common.page, //当前页
          limit: 10, //每页数据条数
          total: undefined, //列表数据总条数
          sortord: '', //排序
          messageTitle: undefined,//标题
          messageLevel: undefined,//级别
          didRead: undefined      //是否已读
        }
      },
      indexMethod(index) {
        return (index += (this.queryParams.page - 1) * this.queryParams.limit + 1)
      },
      paginationChange(param) {
        this.queryParams.limit = param.limit
        this.queryParams.page = param.page
        //代表结束下标
        var end = param.page * param.limit
        // //代表开始下标
        var start = (param.page - 1) * param.limit
        this.systemMessageList = this.systemMessageList2.slice(start, end)
      },
      clearMessageLevel() {
        this.queryParams.messageLevel = undefined
      },
      getDataDictList(condition) {
        this.common
          .httpPost('获取数据字典(消息级别)', 'admin/system/dataDict/getList', condition)
          .then((res) => {
            this.dataDict = res.data.message_level
          })
      },
      searchList() {
        this.queryParams.page = 1;
        var arr = [];
        for (var i = 0; i < this.systemMessageList2.length; i++) {

          if (this.queryParams.messageTitle != undefined && this.queryParams.messageTitle != "") {
            if (this.systemMessageList2[i].messageTitle.split(this.queryParams.messageTitle.trim()).length <= 1) {
              continue;
            }
          }
          if (this.queryParams.messageLevel != undefined && this.queryParams.messageLevel != "") {
            if (this.systemMessageList2[i].messageLevel != this.queryParams.messageLevel) {
              continue;
            }
          }
          if (this.queryParams.didRead != undefined && this.queryParams.didRead != "") {
            if (this.systemMessageList2[i].didRead != parseInt(this.queryParams.didRead)) {
              continue;
            }
          }
          arr.push(this.systemMessageList2[i])
        }
        this.queryParams.total = arr.length;
        this.systemMessageList = arr;
      },
      resetList() {
        this.queryParams = {
          //查询条件参数集合
          page: this.common.page, //当前页
          limit: 10, //每页数据条数
          total: undefined, //列表数据总条数
          sortord: '', //排序
          messageTitle: undefined,
          messageLevel: undefined,
          didRead: undefined
        }
        this.searchList();
      },
    },
    beforeDestroy() {
      this.eventBus.$off('messageList')
    },
    computed: {
      getMessageList() {
        return this.$store.getters.systemMessageList
      }
    },
    watch: {
      getMessageList(newVal, oldVal) {
        this.queryParams.total = newVal.length
        this.systemMessageList2 = newVal
        this.systemMessageList = newVal
      }
    },
    mounted() {
      //获取消息级别信息
      this.getDataDictList(['message_level'])
      this.eventBus.$on('messageList', (params) => {
        // this.systemMessageList = this.$store.getters.systemMessageList.slice(0, this.queryParams.limit);
        this.systemMessageList = this.$store.getters.systemMessageList;
        this.queryParams.total = this.$store.getters.systemMessageList.length;
        this.systemMessageList2 = this.$store.getters.systemMessageList;
        this.MessageDialogVisible = params
      })
    },
  }
</script>

<style>
</style>





// WEBPACK FOOTER //
// src/components/MainLayout/components/UserManagement/messageList.vue